import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLinkTarget } from 'hooks/useLinkTarget';

import { replaceParamListInUrl } from 'utility/Provide/Url';
import { trackGa4Event } from 'utility/Track/trackingHelper';

import { Product, Source } from 'types/common';

import { Conversation as ConversationModel } from 'proto/Community/Conversation';

import { TrackingEvent, TrackingTargetDefault } from '../types';

import styles from './Chat.module.scss';

export interface ChatProps {
    conversation: ConversationModel;
    chatSource: Source;
}

const Chat = ({ conversation, chatSource }: ChatProps) => {
    const { t } = useTranslation();
    const linkTarget = useLinkTarget();
    const { messageList, ctaUrl, ctaText, headline, subline } = conversation;
    const communityLink = replaceParamListInUrl(ctaUrl, [
        { key: 'product', value: Product.Package },
        { key: 'source', value: chatSource },
    ]);
    const trackEvent = () => {
        trackGa4Event(TrackingEvent, {
            click_target: TrackingTargetDefault.All,
        });
    };

    return (
        <div className={styles.ChatBox}>
            <div className={styles.Headline}>{headline}</div>
            <div className={styles.Subline}>{subline}</div>
            {Object.entries(messageList).map(([name, value]) => (
                <div key={name} className={styles.Chat}>
                    {value.avatar?.imageUrl ? (
                        <img
                            className={styles.Avatar}
                            src={value.avatar.imageUrl}
                            alt={t('TRANS-avatar')}
                        />
                    ) : (
                        <div className={styles.Avatar}>
                            {value.name.charAt(0)}
                        </div>
                    )}

                    <div className={styles.Bubble}>{value.message}</div>
                </div>
            ))}
            <a
                onClick={() => trackEvent()}
                rel="noreferrer"
                target={linkTarget}
                className={styles.AreaLink}
                href={communityLink}
                aria-label={ctaText}
            />
            <a
                onClick={() => trackEvent()}
                rel="noreferrer"
                target={linkTarget}
                className={styles.Link}
                href={communityLink}
            >
                {ctaText}
            </a>
        </div>
    );
};

export default Chat;
